/**
 * Decides, for a non-OK response handled with `resolveClientErrors`, whether to
 * resolve the typed JSON body as a final outcome (true) or throw it into the
 * caller's retry/backoff path (false).
 *
 * Resolvable: typed 4xx outcomes the caller branches on (404 invalid_code, 409
 * cap_reached/already_redeemed, 403 not_new_user, etc.).
 *
 * NOT resolvable (must throw → retry):
 * - 401: session expired — re-auth, not a referral outcome.
 * - 429: `rate_limited` is the one transient/retryable reason in the shared
 *   `ReferralRedeemFailReason` contract; resolving it as terminal would clear
 *   the pending code and burn a legitimate referral attribution (the backend
 *   rate-limits /redeem per-IP, reachable on shared/CGNAT IPs).
 * - 5xx / network: handled outside this predicate (always thrown).
 */
export function shouldResolveClientError(status: number): boolean {
  return status >= 400 && status < 500 && status !== 401 && status !== 429;
}
